function r() {
  return r = Object.assign ? Object.assign.bind() : function (r) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var a in n) {
        Object.prototype.hasOwnProperty.call(n, a) && (r[a] = n[a]);
      }
    }

    return r;
  }, r.apply(this, arguments);
}

export { r as _ };